var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2350_892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.28613 9.99999V6.24285C4.29729 5.50432 4.45406 4.77527 4.74748 4.09742C5.04088 3.41959 5.46516 2.80632 5.99599 2.29274C6.52682 1.77917 7.15378 1.37537 7.84093 1.10451C8.52808 0.833651 9.26193 0.701041 10.0004 0.714281C10.7389 0.701041 11.4728 0.833651 12.1599 1.10451C12.8471 1.37537 13.474 1.77917 14.0048 2.29274C14.5357 2.80632 14.96 3.41959 15.2534 4.09742C15.5467 4.77527 15.7036 5.50432 15.7147 6.24285V9.99999",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14342 7.85718H3.57199C3.76143 7.85718 3.94312 7.93243 4.07706 8.06639C4.21102 8.20033 4.28627 8.38202 4.28627 8.57146V12.8572C4.28627 13.0466 4.21102 13.2283 4.07706 13.3622C3.94312 13.4962 3.76143 13.5715 3.57199 13.5715H2.14342C1.76453 13.5715 1.40117 13.4209 1.13326 13.153C0.865354 12.8851 0.714844 12.5218 0.714844 12.1429V9.28575C0.714844 8.90686 0.865354 8.54351 1.13326 8.27559C1.40117 8.00769 1.76453 7.85718 2.14342 7.85718Z",
    stroke: "#current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8577 13.5715H16.4291C16.2397 13.5715 16.058 13.4962 15.924 13.3622C15.7901 13.2283 15.7148 13.0466 15.7148 12.8572V8.57146C15.7148 8.38202 15.7901 8.20033 15.924 8.06639C16.058 7.93243 16.2397 7.85718 16.4291 7.85718H17.8577C18.2366 7.85718 18.6 8.00769 18.8678 8.27559C19.1357 8.54351 19.2863 8.90686 19.2863 9.28575V12.1429C19.2863 12.5218 19.1357 12.8851 18.8678 13.153C18.6 13.4209 18.2366 13.5715 17.8577 13.5715Z",
    stroke: "#current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8584 17.4999C13.6162 17.4999 14.3428 17.1989 14.8787 16.663C15.4145 16.1272 15.7155 15.4005 15.7155 14.6428V11.4285",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8578 17.5001C12.8578 17.9736 12.6697 18.4279 12.3348 18.7628C11.9999 19.0976 11.5457 19.2858 11.0721 19.2858H8.92927C8.45567 19.2858 8.00147 19.0976 7.66658 18.7628C7.3317 18.4279 7.14355 17.9736 7.14355 17.5001C7.14355 17.0265 7.3317 16.5722 7.66658 16.2374C8.00147 15.9025 8.45567 15.7144 8.92927 15.7144H11.0721C11.5457 15.7144 11.9999 15.9025 12.3348 16.2374C12.6697 16.5722 12.8578 17.0265 12.8578 17.5001Z",
    stroke: "#current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2350_892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.23c730e6686cfb39d0cc9f8dc4663d14.svg";
export { ForwardRef as ReactComponent };